/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PageContentMessage } from "../../../messages";
import { toHeaderCase } from "js-convert-case";
const MODULE_NAME =
  "services.CollectionPageService.machines.GetCollectionList.state.formatCollectionChildren";
const log = LoggerModule?.getInstance();

export const formatCollectionChildren = async (context: any, event: any) => {
  console.log(`inside format collection`, context?.input);
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      if (msg?.children?.data && msg?.collection?.collectionList) {
        for (const coll of msg?.children?.data) {
          msg.collection?.collectionList?.push({
            id: coll?.uuid,
            title: toHeaderCase(coll?.name ?? ""),
            description: coll?.description,
            image: coll?.logo,
            catalogueType: "catalogue",
            startDate: coll?.metaData?.startDate,
          });
        }
        msg.collection.totalCount = msg.children.totalCount;
        msg.collection.totalPages = msg.children.totalPages;
        msg.collection.currentPage = msg.children.currentPage;
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatCollectionChildren", err);
      return reject(err?.message);
    }
  });
};
